<script setup lang="ts">
import { SignatureDocumentFieldType } from '@/store/enums';
import {onMounted, Ref, ref} from 'vue';
import {usePortalIntakeStore} from "@/store/PortalIntakeModule";

const props = defineProps<{
    documentIndex: number,
    fieldIndex: number
}>();

const value = ref('');

const intakeStore = usePortalIntakeStore();
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) =>
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});
onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.Relationship, value})
);
</script>

<template>
    <div>
        <p-input-text
            v-model="value"
            placeholder="Relationship to Patient"
            :val="value"
        />
        <span class="signature-form-data signature-form-patient-relationship">
            {{ value }}
        </span>
    </div>
</template>
